import React from 'react'
import { Marker } from 'react-leaflet'
import L from 'leaflet'
import { MapMarkerSvg, MapMarkerOrangeSvg } from 'assets/images'
import { useSelector } from 'react-redux'

const toLatLng = (coord) => {
  if (!coord) return null
  if (Array.isArray(coord)) return coord
  return [coord.lat, coord.lng]
}

const MapMarker = ({ coordinates }) => {
  const channelId = useSelector(({ common }) => common.channelId)

  const icon = L.icon({
    iconUrl: channelId === 'B2B' ? MapMarkerOrangeSvg : MapMarkerSvg,
    iconSize: [32, 40],
    iconAnchor: [16, 40],
  })

  const pos = toLatLng(coordinates)
  if (!pos) return null

  return <Marker position={pos} icon={icon} />
}

export default MapMarker
